module.exports = __webpack_public_path__ + "img/dori-zsolti.84f651ed.jpg";